import React, { useState } from 'react';
import '../styles/GroundsGrid.css';

// Import images from assets folder - all changed to .webp
import fot1 from '../assets/fot1.webp';
import fot2 from '../assets/fot2.webp';
import fot3 from '../assets/fot3.webp';
import lawn1 from '../assets/lawn1.webp';
import lawn7 from '../assets/lawn7.webp';
import pad3 from '../assets/pad3.webp';
import pad4 from '../assets/pad4.webp';
import pad5 from '../assets/pad5.webp';

// New imported images - all changed to .webp
import pickle1 from '../assets/pickle1.webp';
import badminton1 from '../assets/badminton1.webp';
import badminton2 from '../assets/badminton2.webp';
import badminton3 from '../assets/badminton3.webp';
import badminton4 from '../assets/badminton4.webp';
import badminton5 from '../assets/badminton5.webp';
import basket1 from '../assets/basket1.webp';
import basket2 from '../assets/basket2.webp';
import basket3 from '../assets/basket3.webp';
import crick1 from '../assets/crick1.webp';
import crick2 from '../assets/crick2.webp';
import crick3 from '../assets/crick3.webp';
import valley1 from '../assets/valley1.webp';
import valley2 from '../assets/valley2.webp';
import valley3 from '../assets/valley3.webp';
import valley4 from '../assets/valley4.webp';
import valley5 from '../assets/valley5.webp';
import valley6 from '../assets/valley6.webp';

const GroundsGrid = ({ openBookingModal }) => {
  const [activeSport, setActiveSport] = useState('football');
  const [selectedRegion, setSelectedRegion] = useState('all');

  const groundsData = {
    football: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Al Quoz, Dubai', image: fot1, price: '450 AED', size: '7-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah 1', image: fot2, price: '600 AED', size: '11-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Marina', image: fot3, price: '350 AED', size: '5-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Safa', image: fot1, price: '450 AED', size: '7-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Wasl Road', image: fot1, price: '450 AED', size: '7-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Mina Rashid', image: fot1, price: '450 AED', size: '7-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Media City', image: fot2, price: '500 AED', size: '5-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Internet City', image: fot3, price: '550 AED', size: '7-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'The Palm Jumeirah', image: fot1, price: '800 AED', size: '11-a-side', region: 'west' },
      { name: 'All Sports Ground', location: 'Barsha Heights', image: fot2, price: '400 AED', size: '5-a-side', region: 'west' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Al Rigga', image: fot1, price: '300 AED', size: '7-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Deira', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Abu Hail', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Nahda', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Muhaisnah', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Twar', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Garhoud', image: fot2, price: '400 AED', size: '11-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Hor Al Anz', image: fot1, price: '350 AED', size: '7-a-side', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Baraha', image: fot3, price: '320 AED', size: '5-a-side', region: 'east' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Downtown', image: fot3, price: '500 AED', size: '5-a-side', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: fot3, price: '500 AED', size: '5-a-side', region: 'central' },
      { name: 'All Sports Ground', location: 'Dubai Design District', image: fot2, price: '450 AED', size: '7-a-side', region: 'central' },
      { name: 'All Sports Ground', location: 'Al Jaddaf', image: fot1, price: '380 AED', size: '7-a-side', region: 'central' },
      { name: 'All Sports Ground', location: 'Oud Metha', image: fot2, price: '420 AED', size: '5-a-side', region: 'central' },
      { name: 'All Sports Ground', location: 'Al Mankhool', image: fot3, price: '360 AED', size: '7-a-side', region: 'central' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Bur Dubai', image: fot1, price: '350 AED', size: '7-a-side', region: 'north' },
      { name: 'All Sports Ground', location: 'Karama', image: fot2, price: '400 AED', size: '5-a-side', region: 'north' },
      { name: 'All Sports Ground', location: 'Al Mankhool', image: fot2, price: '400 AED', size: '5-a-side', region: 'north' },
      { name: 'All Sports Ground', location: 'Al Raffa', image: fot1, price: '330 AED', size: '7-a-side', region: 'north' },
      { name: 'All Sports Ground', location: 'Al Hudaiba', image: fot3, price: '380 AED', size: '5-a-side', region: 'north' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: fot1, price: '400 AED', size: '7-a-side', region: 'south' },
      { name: 'All Sports Ground', location: 'Arabian Ranches', image: fot2, price: '550 AED', size: '11-a-side', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Investments Park', image: fot3, price: '450 AED', size: '7-a-side', region: 'south' },
      { name: 'All Sports Ground', location: 'Jumeirah Golf Estates', image: fot2, price: '600 AED', size: '5-a-side', region: 'south' },
      { name: 'All Sports Ground', location: 'Al Furjan', image: fot1, price: '420 AED', size: '7-a-side', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Production City', image: fot3, price: '380 AED', size: '5-a-side', region: 'south' }
    ],
    
    cricket: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Al Barsha', image: crick1, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Quoz, Dubai', image: crick2, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah 1', image: crick3, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Marina', image: crick1, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Safa', image: crick2, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Wasl Road', image: crick3, price: '800 AED', size: 'hard ball', region: 'west' },
      { name: 'All Sports Ground', location: 'The Palm Jumeirah', image: crick1, price: '1200 AED', size: 'hard ball', region: 'west' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Al Dhaid Road', image: crick2, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Mina Rashid', image: crick3, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Rigga', image: crick1, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: crick2, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Deira', image: crick3, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Abu Hail', image: crick1, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Nahda', image: crick2, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Muhaisnah', image: crick3, price: '550 AED', size: 'tape ball', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Twar', image: crick1, price: '600 AED', size: 'hard ball', region: 'east' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Arabian Ranches', image: crick2, price: '400 AED', size: 'junior / academy', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: crick3, price: '550 AED', size: 'tape ball', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Investments Park', image: crick1, price: '500 AED', size: 'tape ball', region: 'south' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Business Bay', image: crick2, price: '600 AED', size: 'tape ball', region: 'central' },
      { name: 'All Sports Ground', location: 'Downtown', image: crick3, price: '750 AED', size: 'hard ball', region: 'central' },
      { name: 'All Sports Ground', location: 'Oud Metha', image: crick1, price: '580 AED', size: 'tape ball', region: 'central' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Bur Dubai', image: crick2, price: '520 AED', size: 'tape ball', region: 'north' },
      { name: 'All Sports Ground', location: 'Karama', image: crick3, price: '480 AED', size: 'tape ball', region: 'north' }
    ],
    
    lawnTennis: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Dubai Sports City', image: lawn1, price: '550 AED', size: 'clay court', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah Beach Road', image: lawn7, price: '650 AED', size: 'hard court', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Barsha', image: lawn1, price: '500 AED', size: 'clay court', region: 'west' },
      { name: 'All Sports Ground', location: 'The Palm Jumeirah', image: lawn7, price: '800 AED', size: 'hard court', region: 'west' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Al Wasl', image: lawn7, price: '600 AED', size: 'hard court', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: lawn1, price: '580 AED', size: 'clay court', region: 'central' },
      { name: 'All Sports Ground', location: 'Downtown', image: lawn7, price: '620 AED', size: 'hard court', region: 'central' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Mirdif', image: lawn1, price: '450 AED', size: 'grass court', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: lawn7, price: '480 AED', size: 'hard court', region: 'east' },
      { name: 'All Sports Ground', location: 'Garhoud', image: lawn1, price: '500 AED', size: 'clay court', region: 'east' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: lawn7, price: '420 AED', size: 'hard court', region: 'south' },
      { name: 'All Sports Ground', location: 'Arabian Ranches', image: lawn1, price: '550 AED', size: 'clay court', region: 'south' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Karama', image: lawn7, price: '400 AED', size: 'hard court', region: 'north' },
      { name: 'All Sports Ground', location: 'Bur Dubai', image: lawn1, price: '380 AED', size: 'clay court', region: 'north' }
    ],
    
    padelTennis: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Jumeirah Golf Estates', image: pad3, price: '650 AED', size: 'indoor padel', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Barsha', image: pad4, price: '600 AED', size: 'outdoor padel', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Marina', image: pad5, price: '580 AED', size: 'crystal padel', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah 1', image: pad3, price: '620 AED', size: 'indoor padel', region: 'west' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Dubai Hills', image: pad4, price: '700 AED', size: 'outdoor padel', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: pad5, price: '680 AED', size: 'crystal padel', region: 'central' },
      { name: 'All Sports Ground', location: 'Downtown', image: pad3, price: '720 AED', size: 'indoor padel', region: 'central' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'The Springs', image: pad5, price: '550 AED', size: 'crystal padel', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: pad3, price: '500 AED', size: 'indoor padel', region: 'south' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Mirdif', image: pad4, price: '520 AED', size: 'outdoor padel', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: pad5, price: '480 AED', size: 'crystal padel', region: 'east' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Bur Dubai', image: pad3, price: '450 AED', size: 'indoor padel', region: 'north' }
    ],
    
    badminton: [
      // East Dubai
      { name: 'All Sports Ground', location: 'Al Twar', image: badminton1, price: '350 AED', size: 'indoor court', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: badminton2, price: '320 AED', size: 'training court', region: 'east' },
      { name: 'All Sports Ground', location: 'Mirdif', image: badminton3, price: '340 AED', size: 'professional court', region: 'east' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Garhoud', image: badminton4, price: '400 AED', size: 'professional court', region: 'central' },
      { name: 'All Sports Ground', location: 'Oud Metha', image: badminton5, price: '380 AED', size: 'indoor court', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: badminton1, price: '420 AED', size: 'training court', region: 'central' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Al Nahda', image: badminton2, price: '300 AED', size: 'training court', region: 'north' },
      { name: 'All Sports Ground', location: 'Karama', image: badminton3, price: '280 AED', size: 'indoor court', region: 'north' },
      { name: 'All Sports Ground', location: 'Bur Dubai', image: badminton4, price: '290 AED', size: 'professional court', region: 'north' },
      
      // West Dubai
      { name: 'All Sports Ground', location: 'Al Barsha', image: badminton5, price: '360 AED', size: 'indoor court', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah', image: badminton1, price: '380 AED', size: 'professional court', region: 'west' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: badminton2, price: '320 AED', size: 'training court', region: 'south' }
    ],
    
    basketball: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Al Manara', image: basket1, price: '450 AED', size: 'full court', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Quoz', image: basket2, price: '500 AED', size: 'half court', region: 'west' },
      { name: 'All Sports Ground', location: 'Dubai Marina', image: basket3, price: '480 AED', size: 'full court', region: 'west' },
      { name: 'All Sports Ground', location: 'Jumeirah 1', image: basket1, price: '420 AED', size: 'half court', region: 'west' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Oud Metha', image: basket2, price: '400 AED', size: '3x3 court', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: basket3, price: '520 AED', size: 'full court', region: 'central' },
      { name: 'All Sports Ground', location: 'Downtown', image: basket1, price: '550 AED', size: 'half court', region: 'central' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Al Qusais', image: basket2, price: '350 AED', size: 'full court', region: 'east' },
      { name: 'All Sports Ground', location: 'Mirdif', image: basket3, price: '380 AED', size: 'half court', region: 'east' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Karama', image: basket1, price: '300 AED', size: '3x3 court', region: 'north' },
      { name: 'All Sports Ground', location: 'Bur Dubai', image: basket2, price: '320 AED', size: 'half court', region: 'north' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: basket3, price: '360 AED', size: 'full court', region: 'south' },
      { name: 'All Sports Ground', location: 'Arabian Ranches', image: basket1, price: '400 AED', size: 'half court', region: 'south' }
    ],
    
    volleyball: [
      // West Dubai
      { name: 'All Sports Ground', location: 'JBR', image: valley1, price: '480 AED', size: 'beach volleyball', region: 'west' },
      { name: 'All Sports Ground', location: 'The Palm Jumeirah', image: valley2, price: '550 AED', size: 'beach volleyball', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Barsha', image: valley3, price: '400 AED', size: 'indoor court', region: 'west' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Al Mamzar', image: valley4, price: '350 AED', size: 'indoor court', region: 'north' },
      { name: 'All Sports Ground', location: 'Deira', image: valley5, price: '320 AED', size: 'beach volleyball', region: 'north' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Al Nahda', image: valley6, price: '380 AED', size: 'training court', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: valley1, price: '360 AED', size: 'indoor court', region: 'east' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Downtown', image: valley2, price: '450 AED', size: 'beach volleyball', region: 'central' },
      { name: 'All Sports Ground', location: 'Business Bay', image: valley3, price: '420 AED', size: 'indoor court', region: 'central' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: valley4, price: '340 AED', size: 'training court', region: 'south' }
    ],
    
    pickleball: [
      // West Dubai
      { name: 'All Sports Ground', location: 'Dubai Marina', image: pickle1, price: '320 AED', size: 'standard court', region: 'west' },
      { name: 'All Sports Ground', location: 'JLT', image: pickle1, price: '340 AED', size: 'professional court', region: 'west' },
      { name: 'All Sports Ground', location: 'Al Barsha', image: pickle1, price: '300 AED', size: 'training court', region: 'west' },
      
      // South Dubai
      { name: 'All Sports Ground', location: 'Al Furjan', image: pickle1, price: '300 AED', size: 'training court', region: 'south' },
      { name: 'All Sports Ground', location: 'Dubai Silicon Oasis', image: pickle1, price: '280 AED', size: 'standard court', region: 'south' },
      
      // Central Dubai
      { name: 'All Sports Ground', location: 'Business Bay', image: pickle1, price: '350 AED', size: 'professional court', region: 'central' },
      { name: 'All Sports Ground', location: 'Downtown', image: pickle1, price: '360 AED', size: 'standard court', region: 'central' },
      
      // East Dubai
      { name: 'All Sports Ground', location: 'Mirdif', image: pickle1, price: '270 AED', size: 'training court', region: 'east' },
      { name: 'All Sports Ground', location: 'Al Qusais', image: pickle1, price: '260 AED', size: 'standard court', region: 'east' },
      
      // North Dubai
      { name: 'All Sports Ground', location: 'Karama', image: pickle1, price: '250 AED', size: 'training court', region: 'north' }
    ]
  };

  const sportPills = [
    { id: 'football', label: 'Football', icon: 'fa-futbol' },
    { id: 'cricket', label: 'Cricket', icon: 'fa-baseball-bat-ball' },
    { id: 'lawnTennis', label: 'Lawn Tennis', icon: 'fa-table-tennis-paddle-ball' },
    { id: 'padelTennis', label: 'Padel Tennis', icon: 'fa-table-tennis' },
    { id: 'badminton', label: 'Badminton', icon: 'fa-shuttlecock' },
    { id: 'basketball', label: 'Basketball', icon: 'fa-basketball-ball' },
    { id: 'volleyball', label: 'Volleyball', icon: 'fa-volleyball-ball' },
    { id: 'pickleball', label: 'Pickleball', icon: 'fa-circle' }
  ];

  const regions = [
    { id: 'all', label: 'All Regions', icon: 'fa-globe' },
    { id: 'east', label: 'East Dubai', icon: 'fa-location-dot' },
    { id: 'west', label: 'West Dubai', icon: 'fa-location-dot' },
    { id: 'north', label: 'North Dubai', icon: 'fa-location-dot' },
    { id: 'south', label: 'South Dubai', icon: 'fa-location-dot' },
    { id: 'central', label: 'Central Dubai', icon: 'fa-location-dot' }
  ];

  // Filter grounds based on selected sport and region
  const filteredGrounds = groundsData[activeSport].filter(ground => {
    if (selectedRegion === 'all') return true;
    return ground.region === selectedRegion;
  });

  return (
    <div className="container">
      <h2 className="section-title" id="services">Our <span>services</span></h2>
      
      <h3 className="service1-heading">
        1. Sports Ground Booking <i className="fas fa-futbol" style={{ color: '#F97316' }}></i>
      </h3>
      
      {/* Sport Selector */}
      <div className="sport-selector">
        {sportPills.map(sport => (
          <div
            key={sport.id}
            className={`sport-pill ${activeSport === sport.id ? 'active' : ''}`}
            onClick={() => {
              setActiveSport(sport.id);
              setSelectedRegion('all'); // Reset region when sport changes
            }}
          >
            <i className={`fas ${sport.icon}`}></i> {sport.label}
          </div>
        ))}
      </div>

      {/* Region Selector */}
      <div className="region-selector">
        <h4 className="region-selector-title">Select Region:</h4>
        <div className="region-buttons">
          {regions.map(region => (
            <button
              key={region.id}
              className={`region-btn ${selectedRegion === region.id ? 'active' : ''}`}
              onClick={() => setSelectedRegion(region.id)}
            >
              <i className={`fas ${region.icon}`}></i> {region.label}
            </button>
          ))}
        </div>
      </div>

      {/* Results count */}
      <div className="results-count">
        Found {filteredGrounds.length} grounds in {selectedRegion === 'all' ? 'all regions' : regions.find(r => r.id === selectedRegion)?.label}
      </div>

      {/* Grounds Grid */}
      <div className="grounds-grid">
        {filteredGrounds.map((ground, index) => (
          <div key={index} className="ground-card">
            <div 
              className="ground-img" 
              style={{ backgroundImage: `url(${ground.image})` }}
              loading="lazy"
            >
              <span className="ground-tag">{ground.size}</span>
            </div>
            <div className="ground-info">
              <h4>{ground.name}</h4>
              <div className="ground-location">
                <i className="fa-solid fa-location-dot"></i> {ground.location}
              </div>
              <div className="ground-details location-only">
                <div className="location-highlight">
                  <i className="fa-regular fa-map"></i> 
                  <strong>{ground.location.split(',')[0]}</strong>
                </div>
              </div>
              <button className="book-now-btn" onClick={openBookingModal}>
                Book now <i className="fa-regular fa-calendar-check"></i>
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredGrounds.length === 0 && (
        <div className="no-results">
          <i className="fas fa-map-marked-alt"></i>
          <p>No grounds found in this region. Please try another region.</p>
        </div>
      )}
    </div>
  );
};

export default GroundsGrid;